import type {
    UserProfile
} from './';
import type {
    ApiGeneralException
} from 'x1-base/types';

// Password: Forgot / Reset / Set

export interface SetPassword extends Login {
    newPassword: string;
}

export interface ForgotPassword {
    email: string;
}

export interface VerifyResetToken {
    token: string;
}

export interface ResetPassword {
    token: string;
    password: string;
    newPassword: string;
}

// Tokens

export interface JWTToken {
    access: string;
    refresh?: string;
}

export interface ExpandedJWTToken {
    access: string;
    refresh: string;
    accessExp: number;
    refreshExp: number;
}

export interface UserTokenCookie {
    key: string;
    val: string;
}

export interface JWTAccessToken {
    access: string;
    accessExp: number;
}


// Auth

export interface AuthTokenResponse {
    token: JWTAccessToken;
    user?: UserProfile;
    cookies?: UserTokenCookie[];
}

export interface UserTokenResponse extends Partial<AuthTokenResponse> {
    tokenPair: JWTToken;
}


// Sign In

export interface LoginException extends ApiGeneralException {}

// TODO: Rename Me
export interface CreateUserResponse {
    rememberMe?: boolean;
}

export interface Login {
    email: string;
    password: string;
}

export interface LoginOptions {
    rememberMe?: boolean;
}

export type SignInResponse = AuthTokenResponse & LoginException;

export interface SignInRequest {
    email: string;
    password: string;
}

// Sign Up

export interface SignUpQueryParams {
    email?: string;
    password?: string;
    token?: string;
    first_name?: string;
    last_name?: string;
    gender?: string;
}

export interface SignUpStep1Response {
    email: string;
    password: string;
    token: string;
}
export interface SignUpStep2Request extends SignUpStep1Response {}
export interface SignUpStep2Response extends SignUpStep1Response {}

export interface TokenCookieNames {
    access: string;
    accessExp: string;
    refresh: string;
    refreshExp: string;
}


// Permissions & Visibility

export enum VisibilityRole {
    USER = 'user',
    TEAM = 'team',
    ORG = 'org'
}
